window.$ = window.jQuery = require('jquery');
require('./../vendor/modernizr-custom');
require("@popperjs/core");
require ('bootstrap');
require ('./vendor/jquery.keyboard.js');

import objectFitVideos from 'object-fit-videos';
import objectFitImages from 'object-fit-images';

import gaEvents from './../vendor/ga-events';
import maptoolFunctions from './_maptool_functions';
import maptoolMap from './_maptool_map';
import touchscreenForm from './_touchscreen_form';

$(function() { // Shorthand for $( document ).ready()
    "use strict";
    // Your js script is below this line
    // --------------------------------------------------------------------- //

    window.GA = new gaEvents();
    GA.init();

    window.MaptoolFunctions = new maptoolFunctions();
    MaptoolFunctions.init();

    window.MaptoolMap = new maptoolMap();
    MaptoolMap.init();

    window.TouchscreenForm = new touchscreenForm();
    TouchscreenForm.init();

    $(function() {
        // WebP background image fallback swap
        const checkWebp = function () {
            if (!Modernizr.webp) {
                let $elements = $('*[data-webp-bg-fallback]');
                $elements.each(function() {
                    let fallback = $(this).data('webp-bg-fallback');
                    $(this).css('background-image', 'url(' + fallback + ')');
                });

                // Update img's with fallback
                let $images = $('*[data-webp-img-fallback]');
                $images.each(function() {
                    let fallback =  $(this).data('webp-img-fallback');
                    $(this).attr('src', fallback);
                });
            }
        };

        $(document).on('ajaxUpdate', function(event, context) {
            checkWebp();
        });
        checkWebp();

        $(window).trigger('resize');

        $('html').addClass('ready');
    });

    // Sets inputs as filled when Google autocomplete prefills them
    $(window).on('load', function() {
        $('input:-webkit-autofill').each(function(){
            $(this).parents('.form-group').addClass('focused filled');
        });
    });

    objectFitVideos();
    objectFitImages('img');
});